import { createFileRoute } from '@tanstack/react-router'
import { SchemaFlowView } from '../../components/project-inspector'

export const Route = createFileRoute('/dev/db-schema')({
  component: SchemaFlowView,
})
